import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenService } from '../../services/authen.service';
import { PrincipalUser } from "../../models/Principal/principal-user.model";
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { DataManager } from '@syncfusion/ej2-data';
import { MyDataAdaptor } from '../../helpers/grid.adaptor';
import { HelperService } from '../../services/helper.service';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
@Component({
    selector: '',
    templateUrl: 'principal-user-detail.html',
    encapsulation: ViewEncapsulation.None
})
export class PrincipalUserDetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    principalUser = new PrincipalUser();
    areaDDL: Array<any> = [];
    valueArea: Array<any> = [];
    principalDDL: Array<any> = [];
    fields: Object = { text: 'label', value: 'value' };
    userTypeDDL: Array<any> = [
        //{ label: "Tender ZPV", value: "ZPV" },
        //{ label: "Principal User", value: "PRN" },
        //{ label: "Mobile User", value: "MOBILE" }

        { label: "HS", value: "HS" },
        { label: "FFM", value: "FFM" },
        { label: "SC", value: "SC" }
    ];
    viewReportDDL: Array<any> = [
        { label: "Market Inteligence", value: "1" },
        { label: "Tender Management", value: "2" },
        { label: "Report", value: "3" },
        { label: "Promotion", value: "4" },
    ];
    valueViewReport: Array<any> = [];
    receiveEmail: Array<any> = [
        { label: "Update Market Inteligence", value: "1" },
        { label: "Tender Invitation", value: "2" },
        { label: "Approval remind", value: "3" },
        { label: "Over deadline", value: "4" },
        { label: "Results", value: "5" },
    ];
    valueReceiveEmail: Array<any> = [];
    accessRights: Array<any> = [
        { label: "Read", value: 1 },
        { label: "Write", value: 2 },

    ];
    constructor(private auth: AuthenService, private route: ActivatedRoute, private router: Router, private helper: HelperService,
        private http: HttpService) {

        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
            if (this.id) {
                this.getPrincipalUserByID(this.id);
            }


        });
    }

    ngOnInit() {
        //this.getAreaDDL();
        //this.getPrincipalDDL();
    }
    getPrincipalUserByID(id) {
        this.http.get('api/PrincipalUser/GetPrincipalUserByID/' + id, res => {
            this.principalUser = res.Result;
            this.valueReceiveEmail = this.principalUser.ReceiveEmail ? this.principalUser.ReceiveEmail.split(",") : [];
            this.valueViewReport = this.principalUser.ViewReport ? this.principalUser.ViewReport.split(",") : [];
            this.valueArea = this.principalUser.Area ? this.principalUser.Area.split(",") : [];
        }, null);
    }
    savePrincipalUser() {
        var dataSave = this.principalUser;
        dataSave.ReceiveEmail = this.valueReceiveEmail.length > 0 ? this.valueReceiveEmail.join(",") : null;
        dataSave.ViewReport = this.valueViewReport.length > 0 ? this.valueViewReport.join(",") : null;
        dataSave.Area = this.valueArea.length > 0 ? this.valueArea.join(",") : null;

        var valid = this.validateSave();
        if (valid) {

            this.http.save('api/PrincipalUser/SavePrincipalUser', dataSave, res => {
                //this.principalUser.ID = res.ID;
                //this.router.navigate(['/principal-user-detail', res.ID]);

                if (res.ID < 0) {
                    this.helper.alertFailed("Username already exists !");
                }
                else {
                    this.principalUser.ID = res.ID;
                    this.router.navigate(['/principal-user-detail', res.ID]);
                }           
            }, null);

        } else {
            this.helper.alertFailed("Require fields can not empty.");
        }




    }
    onChangeApproval_1(e) {
        this.principalUser.Approval_1 = !this.principalUser.Approval_1;
    }
    onChangeApproval_2(e) {
        this.principalUser.Approval_2 = !this.principalUser.Approval_2;
    }
    onChangeActive(e) {

        this.principalUser.IsActive = !this.principalUser.IsActive;
    }
    getAreaDDL() {
        this.http.get('api/CommonFunc/GetAreaDDL', res => {
            this.areaDDL = res;
        }, null);
    }
    //getPrincipalDDL() {
    //    this.http.get('api/PrincipalUser/GetAllPrincipalDDL?prnEx=' + this.auth.PrincipalEx, res => {
    //        this.principalDDL = res;
    //    }, null);
    //}
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
    validateSave() {
        if (this.principalUser.UserName
            && this.principalUser.Pwd
            //&& this.principalUser.AccessRight
            //&& this.principalUser.PRNGroup
            && this.principalUser.Email) {
            var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i;
            if (!reg.test(this.principalUser.Pwd)) {
                this.helper.alertFailed('Mật khẩu phải có ít nhất 8 ký tự, có chữ, số và ký tự đặc biệt/ Minimum eight characters, at least one letter, one number and one special character.');
                return false;
            }
            reg = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            if (!reg.test(this.principalUser.Email)) {
                this.helper.alertFailed(this.principalUser.Email + ': không phải là email hoặc sai định dạng email.', 'Failed');
                return false;
            }
            return true;
        } else {
            return false;
        }
    }
}
